<div class='producer-agency-modal-content'>

  @if (!currentPathDisablesChangeAgency) {
    <h2 mat-dialog-title>{{ modalTitle }}</h2>
    @if (modalDesc) {
      <mat-dialog-content>
        <p>{{ modalDesc }}</p>
      </mat-dialog-content>
    }
    <div class="change-agency-component-container">
      <app-producer-change-agency
        [enrollmentSubmitMode]="this.data.enrollmentSubmitMode"
        [isAgencyOnlyMode]="true"
        [selectedMarket]="data.lob"
        [showRegionFilter]="data.showRegionFilter"
        [ignoreCookieUpdates]="true"
        (agencyChangeEvent)="agencyChange($event)"
        >
      </app-producer-change-agency>
    </div>
  } @else {
    <mat-dialog-content>
      <p>Changing your agency is disabled on view product and enrollment pages.<br/><br/>Please return to the beginning of the view products flow to change your agency.</p>
    </mat-dialog-content>
  }


</div>